import { IconSvg, IconSvgProps } from "./icon"

export default function Circle(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14h0Z" />
    </IconSvg>
  )
}
